<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Add new</h1>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="newItem.data" auto-grow rows="1" label="Content text"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="newItem.img" label="Link to image"></v-text-field>
      </v-col>
      <v-col cols="12">
        <h2>Select date:</h2>
      </v-col>
      <v-col cols="12">
        <v-date-picker v-model="newItem.date"></v-date-picker>
      </v-col>
      <v-col cols="12">
        <v-btn :loading="loading" color="white" elevation="1" @click="create">Add</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-select
          v-model="id"
          :items="newsFormatted"
          item-text="dateString"
          item-value="id"
          dense
          label="New to edit"
          filled
          @input="updateItem"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="id">
      <v-col cols="12">
        <v-textarea v-model="item.data" auto-grow rows="1" label="Content text"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="item.img" label="Link to image"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-date-picker v-model="item.date"></v-date-picker>
      </v-col>
      <v-col cols="6">
        <v-btn :loading="loading" color="white" elevation="1" @click="update">Update</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn :loading="loading" color="red" elevation="1" @click="delet">Delete</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { getFirestoreDate } from "@/helpers/firestore.js";

export default {
  name: "NewsEdit",
  data() {
    return {
      id: null,
      item: {},
      loading: false,
      newItem: {
        date: null,
        data: null,
        img:null
      }
    };
  },
  computed: {
    ...mapState(["loadingNews", "news"]),
    newsFormatted() {
      return this.news.map(x => {
        if (x)
          return {
            ...x,
            dateString: x.data
          };
      });
    }
  },
  mounted() {
    if (!this.news.length) this.$store.dispatch("cargarNews");
  },

  methods: {
    updateItem() {
      Object.assign(
        this.item,
        this.news.find(val => val.id === this.id)
      );
      this.item.date = this.item.date
        .toDate()
        .toISOString()
        .substr(0, 10);
    },
    update() {
      this.loading = true;
      if (this.id) {
        let updatedItem = {};
        Object.assign(updatedItem, this.item);
        updatedItem.date = getFirestoreDate(this.item.date);
        this.$store
          .dispatch("updateNews", updatedItem)
          .then(() => ((this.loading = false), alert("Content updated!")));
      }
    },
    create() {
      if (this.newItem.data && this.newItem.date) {
        let updatedItem = {};
        Object.assign(updatedItem, this.newItem);
        updatedItem.date = getFirestoreDate(this.newItem.date);
        this.$store
          .dispatch("addNews", updatedItem)
          .then(() => ((this.loading = false), alert("Content added!")))
          .catch(error => {
            console.log(error);
            alert("Error! Fill up all the fields or try again later!");
          });
      } else {
        alert("Fill up all the fields!");
      }
    },
    delet() {
      this.loading = true;
      this.$store
        .dispatch("deleteNews", this.item)
        .then(() => (this.loading = false));
      this.item = {};
    }
  }
};
</script>